"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PHONE_TEN_DIGIT = exports.EMAIL_MULTI = exports.EMAIL = exports.SSN = exports.FEIN = exports.MAXIMUM_VALUE = exports.MINIMUM_VALUE = exports.MAXIMUM_CHARACTERS = exports.MINIMUM_CHARACTERS = exports.NUMBERS_REQUIRED = exports.LETTERS_REQUIRED = exports.COLORADO_ADDRESS = exports.REQUIRED = void 0;
// General Validation
var REQUIRED = 'REQUIRED';
exports.REQUIRED = REQUIRED;
var COLORADO_ADDRESS = 'COLORADO_ADDRESS';
exports.COLORADO_ADDRESS = COLORADO_ADDRESS;
var LETTERS_REQUIRED = 'LETTERS_REQUIRED';
exports.LETTERS_REQUIRED = LETTERS_REQUIRED;
var NUMBERS_REQUIRED = 'NUMBERS_REQUIRED';
exports.NUMBERS_REQUIRED = NUMBERS_REQUIRED;
var MINIMUM_CHARACTERS = 'MINIMUM_CHARACTERS';
exports.MINIMUM_CHARACTERS = MINIMUM_CHARACTERS;
var MAXIMUM_CHARACTERS = 'MAXIMUM_CHARACTERS';
exports.MAXIMUM_CHARACTERS = MAXIMUM_CHARACTERS;
var MINIMUM_VALUE = 'MINIMUM_VALUE';
exports.MINIMUM_VALUE = MINIMUM_VALUE;
var MAXIMUM_VALUE = 'MAXIMUM_VALUE'; // Input-Specific Validation

exports.MAXIMUM_VALUE = MAXIMUM_VALUE;
var FEIN = 'FEIN';
exports.FEIN = FEIN;
var SSN = 'SSN';
exports.SSN = SSN;
var EMAIL = 'EMAIL';
exports.EMAIL = EMAIL;
var EMAIL_MULTI = 'EMAIL_MULTI';
exports.EMAIL_MULTI = EMAIL_MULTI;
var PHONE_TEN_DIGIT = 'PHONE_TEN_DIGIT';
exports.PHONE_TEN_DIGIT = PHONE_TEN_DIGIT;
var _default = {
  REQUIRED: REQUIRED,
  LETTERS_REQUIRED: LETTERS_REQUIRED,
  NUMBERS_REQUIRED: NUMBERS_REQUIRED,
  MINIMUM_CHARACTERS: MINIMUM_CHARACTERS,
  MAXIMUM_CHARACTERS: MAXIMUM_CHARACTERS,
  MINIMUM_VALUE: MINIMUM_VALUE,
  MAXIMUM_VALUE: MAXIMUM_VALUE,
  EMAIL: EMAIL,
  EMAIL_MULTI: EMAIL_MULTI,
  FEIN: FEIN,
  SSN: SSN,
  PHONE_TEN_DIGIT: PHONE_TEN_DIGIT,
  COLORADO_ADDRESS: COLORADO_ADDRESS
};
exports.default = _default;